import VerticalSpacer from 'components/Common/Spacing/VerticalSpacer'
import CSSBreakpoint from 'components/utils/CSSBreakpoint'
import Group from 'components/utils/Group'
import Sheet from 'components/utils/Sheet'
import ModalContext from 'contexts/ModalContext'
import TextButton from 'LuxKit/Button/TextButton'
import LineGlobeAltIcon from 'LuxKit/Icons/line/LineGlobeAltIcon'
import LineStarIcon from 'LuxKit/Icons/line/LineStarIcon'
import StructureLabel from 'LuxKit/Label/StructureLabel'
import BodyTextBlock from 'LuxKit/TextBlocks/BodyTextBlock'
import { rem } from 'polished'
import React, { useContext } from 'react'
import styled from 'styled-components'
import CharterBundleLearnMoreModal from './CharterBundleLearnMoreModal'
import LineCalendarCheckIcon from 'LuxKit/Icons/line/LineCalendarCheckIcon'
import LineClockWithTickIcon from 'LuxKit/Icons/line/LineClockWithTickIcon'
import LinePlaneDepartureIcon from 'LuxKit/Icons/line/LinePlaneDepartureIcon'

const LABEL_OFFSET = 12

const Root = styled.div`
  padding-top: ${rem(LABEL_OFFSET)};
`

const RelativeSheet = styled(Sheet)`
  position: relative;
`

const AbsoluteLabel = styled(StructureLabel)`
  position: absolute;
  top: ${rem(-LABEL_OFFSET)};
  left: -1px;
`

const MainContent = styled(VerticalSpacer)`
  flex: 1;
`

function CharterBundleUSPs() {
  const showModal = useContext(ModalContext)

  const showLearnMoreModal = () => {
    showModal(<CharterBundleLearnMoreModal />)
  }

  return <Root>
    <RelativeSheet border="highlight-primary" padding="28 20 20 20" borderRadius="S">
      <AbsoluteLabel variant="promotion">Flight highlights</AbsoluteLabel>
      <Group direction="vertical" desktopDirection="horizontal" verticalAlign="end" horizontalAlign="start">
        <MainContent gap={4}>
          <BodyTextBlock variant="medium" startIcon={<LineGlobeAltIcon />}><b>Australia's only direct flights</b> for a seamless journey to the Maldives.</BodyTextBlock>
          <BodyTextBlock variant="medium" startIcon={<LinePlaneDepartureIcon />}><b>Save up to 20 hours in transit*</b> when you fly direct from Melbourne.</BodyTextBlock>
          <BodyTextBlock variant="medium" startIcon={<LineCalendarCheckIcon />}><b>Free cancellation</b> within 7 days, and flexible date change options. Conditions apply</BodyTextBlock>
          <BodyTextBlock variant="medium" startIcon={<LineClockWithTickIcon />}><b>Early check-in & late checkout</b> give you extra time to enjoy the Maldives.</BodyTextBlock>
          <BodyTextBlock variant="medium" startIcon={<LineStarIcon />}><b>Luxury Escapes private charter</b> aboard a full service A330-200 aircraft.</BodyTextBlock>
        </MainContent>
        <CSSBreakpoint max="tablet">
          <TextButton kind="tertiary" horizontalOutdent="start" onClick={showLearnMoreModal}>Learn more</TextButton>
        </CSSBreakpoint>
        <CSSBreakpoint min="desktop">
          <TextButton kind="tertiary" onClick={showLearnMoreModal}>Learn more</TextButton>
        </CSSBreakpoint>
      </Group>
    </RelativeSheet>
  </Root>
}

export default CharterBundleUSPs
